module.exports = __webpack_public_path__ + "static/media/PaymentLoyaltyScreen.9694b36e.png";